import Grid from '@mui/material/Grid';
import PageTitle from 'src/components/PageTitle';
import CommandDiagnostics from './CommandDiagnostics';

function CommandsDashboard() {
  return (
    <>
      <PageTitle />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CommandDiagnostics />
        </Grid>
      </Grid>
    </>
  );
}

export default CommandsDashboard;
